// extracted by mini-css-extract-plugin
export default {"statusWrapper":"styles_statusWrapper__nZ2dl"};